import { Grid } from "@mui/material";
import { Contract } from "../../app/backendTypes";
import Error from "../common/Error";
import Loading from "../common/Loading";
import { useContracts } from "../../app/hooks";
import ContractCard from "./ContractCard";

export default function Contracts() {
  const { contracts, loading, error } = useContracts();

  if (loading) return <Loading />;

  if (error) return <Error error={error} />;

  return (
    <Grid container spacing={4} justifyContent="center">
      {contracts.map((contract, i) => (
        <Grid size="auto" key={i}>
          <ContractCard contract={contract as Contract} />
        </Grid>
      ))}
    </Grid>
  );
}
